(function () {
  'use strict';

  const HUB_SELECTOR = '[data-cat-food-hub]';
  const HIDDEN_TAG = 'cat-menu-hidden';
  const FEATURED_TAG = 'cat-menu-featured';
  const PRIMARY_TAG = 'cat-menu-primary';
  const BRAND_TAG_PREFIX = 'cat-menu-brand:';

  const BRAND_ALIASES = {
    'ParkCat貓樂園': 'ParkCat 貓樂園',
    'ROYALCANIN 法國皇家': 'ROYAL CANIN 法國皇家',
    'DogCatStar 汪喵星球': '汪喵星球',
    'Natural Signature 自然印記': '自然印記',
    'Unicharm 日本嬌聯': '銀湯匙',
    'LitoMon 怪獸部落': '怪獸部落',
    'ねこ 吶一口': '吶一口'
  };

  const ALPHAPETS_TITLE_BRANDS = [
    ['EATMEE', 'EATMEE 易特咪'],
    ['易特咪', 'EATMEE 易特咪'],
    ['OHANA', 'OHANA 歐哈吶'],
    ['歐哈吶', 'OHANA 歐哈吶'],
    ['鮪魚將軍', '鮪魚將軍'],
    ['爆好滋', '爆好滋'],
    ['PANI', 'PANI 帕尼']
  ];

  const DEFAULT_FEATURED_BRANDS = ['PARKCAT', 'ROYAL CANIN'];
  const DEFAULT_PRIMARY_BRANDS = [
    'TOMA-PRO',
    '汪喵星球',
    '自然印記',
    'ACANA',
    'BELIF',
    'CAT POOL'
  ];

  function tagsFor(product) {
    if (Array.isArray(product.tags)) return product.tags.map(tag => String(tag).trim());
    if (typeof product.tags === 'string') {
      return product.tags.split(',').map(tag => tag.trim()).filter(Boolean);
    }
    return [];
  }

  function hasTag(product, wantedTag) {
    const wanted = wantedTag.toLowerCase();
    return tagsFor(product).some(tag => tag.toLowerCase() === wanted);
  }

  function brandOverride(product) {
    const override = tagsFor(product).find(tag => tag.toLowerCase().startsWith(BRAND_TAG_PREFIX));
    return override ? override.slice(override.indexOf(':') + 1).trim() : '';
  }

  function brandFor(product) {
    const override = brandOverride(product);
    if (override) return override;

    const vendor = String(product.vendor || '').trim();
    if (vendor === 'Alphapets 艾爾發寵物') {
      const title = String(product.title || '').toUpperCase();
      const match = ALPHAPETS_TITLE_BRANDS.find(([needle]) => title.includes(needle.toUpperCase()));
      if (match) return match[1];
    }

    return BRAND_ALIASES[vendor] || vendor || '其他品牌';
  }

  function isAvailable(product) {
    return Array.isArray(product.variants) && product.variants.some(variant => variant.available);
  }

  function productImage(product) {
    const image = Array.isArray(product.images) ? product.images[0] : null;
    return image && image.src ? image.src : '';
  }

  function sizedImage(src, width) {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      return src;
    }
  }

  function productUrl(product) {
    return `/products/${encodeURIComponent(product.handle)}`;
  }

  function canonical(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toUpperCase();
  }

  function matchesBrand(group, needle) {
    return canonical(group.name).includes(canonical(needle));
  }

  function uniquePush(list, group) {
    if (group && !list.includes(group)) list.push(group);
  }

  function chooseProduct(group) {
    return group.products.find(product => hasTag(product, FEATURED_TAG) && isAvailable(product) && productImage(product))
      || group.products.find(product => isAvailable(product) && productImage(product))
      || group.products.find(product => productImage(product))
      || group.products[0];
  }

  function groupProducts(products) {
    const groups = new Map();

    products.forEach((product, index) => {
      if (hasTag(product, HIDDEN_TAG) || !product.handle || !productImage(product)) return;
      const brand = brandFor(product);
      if (!groups.has(brand)) {
        groups.set(brand, {
          name: brand,
          products: [],
          firstIndex: index,
          featured: false,
          primary: false
        });
      }
      const group = groups.get(brand);
      group.products.push(product);
      group.featured = group.featured || hasTag(product, FEATURED_TAG);
      group.primary = group.primary || hasTag(product, PRIMARY_TAG);
    });

    return Array.from(groups.values()).map(group => {
      group.product = chooseProduct(group);
      return group;
    });
  }

  function productGroup(product) {
    const type = String(product.product_type || '').trim();
    if (type === '貓乾糧') return 'dry';
    if (type === '主食罐') return 'wet';
    if (type === '貓副食罐') return 'supplemental';
    return '';
  }

  function partitionProducts(products) {
    const partitions = { dry: [], wet: [], supplemental: [] };

    products.forEach(product => {
      if (hasTag(product, HIDDEN_TAG) || !product.handle || !productImage(product)) return;
      const group = productGroup(product);
      if (group) partitions[group].push(product);
    });

    return partitions;
  }

  function orderGroups(groups) {
    const featured = [];
    groups.filter(group => group.featured).forEach(group => uniquePush(featured, group));
    DEFAULT_FEATURED_BRANDS.forEach(needle => {
      uniquePush(featured, groups.find(group => matchesBrand(group, needle)));
    });
    groups.forEach(group => {
      if (featured.length < 2) uniquePush(featured, group);
    });

    const heroGroups = featured.slice(0, 2);
    const remaining = groups.filter(group => !heroGroups.includes(group));
    const primary = [];

    remaining.filter(group => group.primary).forEach(group => uniquePush(primary, group));
    DEFAULT_PRIMARY_BRANDS.forEach(needle => {
      uniquePush(primary, remaining.find(group => matchesBrand(group, needle)));
    });
    remaining.forEach(group => {
      if (primary.length < 6) uniquePush(primary, group);
    });

    const primaryGroups = primary.slice(0, 6);
    const moreGroups = remaining.filter(group => !primaryGroups.includes(group));
    return { heroGroups, primaryGroups, moreGroups };
  }

  function makeElement(tagName, className, text) {
    const element = document.createElement(tagName);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function makeImage(product, alt, width, eager) {
    const image = document.createElement('img');
    image.src = sizedImage(productImage(product), width);
    image.alt = alt;
    image.width = width;
    image.height = width;
    image.loading = eager ? 'eager' : 'lazy';
    image.decoding = 'async';
    return image;
  }

  function productPrice(product) {
    const prices = (Array.isArray(product.variants) ? product.variants : [])
      .map(variant => Number.parseFloat(variant.price))
      .filter(price => Number.isFinite(price));
    if (!prices.length) return '';
    return `$${Math.min(...prices).toLocaleString('zh-TW')}`;
  }

  function buildCatalogCard(product, index) {
    const link = makeElement('a', 'cat-food-hub__product-card');
    link.href = productUrl(product);
    link.setAttribute('data-drawer-link', '');
    link.dataset.productHandle = product.handle;
    link.style.setProperty('--product-order', String(Math.min(index + 1, 6)));

    const imageWrap = makeElement('span', 'cat-food-hub__product-image');
    imageWrap.appendChild(makeImage(product, product.title, 320, index < 4));
    link.appendChild(imageWrap);

    const copy = makeElement('span', 'cat-food-hub__product-copy');
    copy.appendChild(makeElement('small', '', brandFor(product)));
    copy.appendChild(makeElement('strong', '', product.title));
    const price = productPrice(product);
    if (price) copy.appendChild(makeElement('em', '', price));
    link.appendChild(copy);

    return link;
  }

  function isCatFood(product) {
    if (hasTag(product, HIDDEN_TAG) || !product.handle || !productImage(product)) return false;
    return String(product.product_type || '').trim() !== '狗副食罐';
  }

  // Alpha Loyal ranking (best first) rendered into data-cat-food-rank by Liquid.
  // Ranked products lead in that order; the rest keep collection order.
  function rankProducts(hub, products) {
    let handles = [];
    try {
      handles = JSON.parse(hub.dataset.catFoodRank || '[]') || [];
    } catch (error) {
      handles = [];
    }
    if (!Array.isArray(handles) || !handles.length) return products;

    const position = new Map(handles.map((handle, index) => [handle, index]));
    const rankOf = product => position.has(product.handle) ? position.get(product.handle) : Infinity;
    return products
      .map((product, index) => ({ product, index }))
      .sort((a, b) => (rankOf(a.product) - rankOf(b.product)) || (a.index - b.index))
      .map(entry => entry.product);
  }

  function orderedProductGroups(products) {
    const ordered = orderGroups(groupProducts(products));
    return [...ordered.heroGroups, ...ordered.primaryGroups, ...ordered.moreGroups].slice(0, 4);
  }

  function renderPathCards(hub, partitions) {
    hub.querySelectorAll('[data-cat-food-group]').forEach(card => {
      const group = card.dataset.catFoodGroup;
      const products = partitions[group] || [];
      const count = card.querySelector('[data-cat-food-group-count]');
      const visual = card.querySelector('[data-cat-food-group-image]');
      const representative = orderedProductGroups(products)[0]?.product;

      if (count) count.textContent = `${products.length} 款`;
      if (visual && representative && !visual.querySelector('[data-cat-food-curated-image]')) {
        visual.replaceChildren(makeImage(representative, '', 180, false));
        visual.classList.add('is-loaded');
      }
    });
  }

  function renderHub(hub, products) {
    const partitions = partitionProducts(products);
    const allCatProducts = rankProducts(hub, products.filter(isCatFood));
    const groups = groupProducts(allCatProducts);

    renderPathCards(hub, partitions);

    const catalog = hub.querySelector('[data-cat-food-all-products]');
    if (catalog) {
      // Optional cap so a compact host (the desktop mega menu) can show a short
      // strip instead of the full catalogue. Absent attribute = render everything.
      const limit = Number.parseInt(hub.dataset.catFoodLimit, 10);
      const visible = Number.isFinite(limit) && limit > 0
        ? allCatProducts.slice(0, limit)
        : allCatProducts;
      // Reuse the server-rendered ranked cards so their images don't reload.
      const prerendered = new Map(
        Array.from(catalog.querySelectorAll('[data-product-handle]')).map(card => [card.dataset.productHandle, card])
      );
      catalog.replaceChildren(...visible.map((product, index) => {
        const card = prerendered.get(product.handle);
        if (!card) return buildCatalogCard(product, index);
        card.style.setProperty('--product-order', String(Math.min(index + 1, 6)));
        return card;
      }));
    }

    const count = hub.querySelector('[data-cat-food-all-count]');
    if (count) count.textContent = `${allCatProducts.length} 款`;

    const status = hub.querySelector('[data-cat-food-status]');
    if (status) {
      status.textContent = `已同步 ${allCatProducts.length} 款貓食品・${groups.length} 個品牌`;
      status.hidden = true;
    }
  }

  async function loadHub(hub) {
    if (hub.dataset.catFoodState === 'loading' || hub.dataset.catFoodState === 'loaded') return;
    const endpoint = hub.dataset.catFoodEndpoint;
    const status = hub.querySelector('[data-cat-food-status]');
    hub.dataset.catFoodState = 'loading';
    // Ranked cards are already on screen; sync quietly behind them.
    if (status && !hub.querySelector('[data-cat-food-all-products] [data-product-handle]')) {
      status.hidden = false;
      status.textContent = '正在同步最新品牌…';
    }

    try {
      const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const payload = await response.json();
      const products = Array.isArray(payload.products) ? payload.products : [];
      const partitions = partitionProducts(products);
      if (!Object.values(partitions).some(group => group.length)) throw new Error('No eligible cat-food products');
      renderHub(hub, products);
      hub.dataset.catFoodState = 'loaded';
    } catch (error) {
      hub.dataset.catFoodState = 'error';
      if (status) {
        status.hidden = false;
        status.textContent = '貓食品目錄暫時無法同步，請直接查看所有貓食品。';
      }
      console.warn('[cat-food-menu] catalog sync failed', error);
    }
  }

  function initHub(hub) {
    if (hub.dataset.catFoodInitialized === 'true') return;
    hub.dataset.catFoodInitialized = 'true';

    const observer = new MutationObserver(() => {
      if (hub.classList.contains('is-active')) loadHub(hub);
    });
    observer.observe(hub, { attributes: true, attributeFilter: ['class'] });

    if (hub.classList.contains('is-active')) loadHub(hub);
  }

  function initAll() {
    document.querySelectorAll(HUB_SELECTOR).forEach(initHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
